import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => {
  return {
    toolbar: {
      backgroundColor: '#222',
      border: '2px solid #888',
      borderRadius: '7px',
      height: '50px',
      padding: '2px',
      position: 'fixed',
      right: '40px',
      top: '50px',
      width: '100px',
      zIndex: '10',
    },

    zoomIcon: {
      backgroundColor: '#FE8',
      border: '1px solid #888',
      borderRadius: '5px',
      color: 'black',
      fontSize: '12px',
      fontWeight: 'bold',
      height: '24px',
      margin: '2px',
      width: '32px',
    },

    zoomPercent: {
      color: 'white',
      fontSize: '16px',
      margin: '2px',
      textAlign: 'center',
    },
  };
});

export default ({ scale, onZoomIn, onZoomOut }) => {
  const classes = useStyles();
  const [currentScale, setCurrentScale] = useState(scale);
  useEffect(() => {
    setCurrentScale(scale);
  }, [scale]);

  return (
    <div className={classes.toolbar}>
      <button type="button" className={classes.zoomIcon} onClick={onZoomIn}>
        +
      </button>
      <button type="button" className={classes.zoomIcon} onClick={onZoomOut}>
        -
      </button>
      <div className={classes.zoomPercent}>{(currentScale * 100).toFixed(1)}%</div>
    </div>
  );
};
